<ng-template [cdkPortalOutlet]="portal"> </ng-template>
<button (click)="close()">
	<tk-icon class="cross" icon="cross" size="32" />
</button>
